import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { appsettings } from "@/settings/appsettings";
import { UpdatePartidaTorneoDTO } from "@/interfaces/Live";

// Definir las props

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEditarPartidaGestion',
  props: {
    isVisible: { type: Boolean },
    partida: {}
  },
  emits: ["confirm", "cerrar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emitir eventos
const emit = __emit;

// Variables reactivas
const isModalEditarPartidaVisible = ref<boolean>(props.isVisible);
const partidaEditada = ref<UpdatePartidaTorneoDTO>({
  idPartidaTorneo: props.partida.idPartidaTorneo,
  resultadoUsuario1: props.partida.resultadoUsuario1,
  resultadoUsuario2: props.partida.resultadoUsuario2,
  escenarioPartida: props.partida.escenarioPartida,
  ganadorPartidaTorneo: props.partida.ganadorPartidaTorneo,
  partidaValidadaUsuario1: props.partida.partidaValidadaUsuario1,
  partidaValidadaUsuario2: props.partida.partidaValidadaUsuario2,
  liderMuertoUsuario1: props.partida.liderMuertoUsuario1,
  liderMuertoUsuario2: props.partida.liderMuertoUsuario2,
});
const isFormValid = ref<boolean>(false);

const listaEscenarios = ref<string[]>([]);
const isLoading = ref<boolean>(false);

// Función para cerrar el modal
const cerrarModal = () => {
  emit("cerrar");
};

// Función para confirmar la edición
const confirmarEditarPartida = () => {
  emit("confirm", partidaEditada.value);
};

// Monitorea cambios en la visibilidad del modal
watch(
  () => props.isVisible,
  (newVal) => {
    isModalEditarPartidaVisible.value = newVal;
  }
);

// Monitorea cambios en los datos de la partida
watch(
  () => props.partida,
  (newPartida) => {
    partidaEditada.value = { ...newPartida };
  },
  { immediate: true }
);

// Cargar escenarios
const loadEscenarios = async () => {
  isLoading.value = true;

  listaEscenarios.value = await appsettings.escenarios;

  isLoading.value = false;
};

// Reglas de validación
const rules = {
  required: (value: any) =>
    (value !== null && value !== undefined && value !== "") ||
    "Este campo es obligatorio",
  isNumber: (value: number) => !isNaN(value) || "Debe ser un número",
  isBool: (value: boolean) =>
    value == true || value == false || "Este campo es obligatorio",
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isModalEditarPartidaVisible.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isModalEditarPartidaVisible).value = $event)),
    "max-width": "400"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(" Editar partida ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref: "form",
                modelValue: isFormValid.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isFormValid).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    label: `Puntos de ${props.partida.nick1}`,
                    modelValue: partidaEditada.value.resultadoUsuario1,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((partidaEditada.value.resultadoUsuario1) = $event)),
                    type: "number",
                    rules: [rules.required, rules.isNumber]
                  }, null, 8, ["label", "modelValue", "rules"]),
                  _createVNode(_component_v_text_field, {
                    label: `Puntos de ${props.partida.nick2}`,
                    modelValue: partidaEditada.value.resultadoUsuario2,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((partidaEditada.value.resultadoUsuario2) = $event)),
                    type: "number",
                    rules: [rules.required, rules.isNumber]
                  }, null, 8, ["label", "modelValue", "rules"]),
                  _createVNode(_component_v_combobox, {
                    modelValue: partidaEditada.value.escenarioPartida,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((partidaEditada.value.escenarioPartida) = $event)),
                    items: listaEscenarios.value,
                    onClick: loadEscenarios,
                    label: "Escenario"
                  }, null, 8, ["modelValue", "items"]),
                  _createVNode(_component_v_radio_group, {
                    modelValue: partidaEditada.value.liderMuertoUsuario1,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((partidaEditada.value.liderMuertoUsuario1) = $event)),
                    label: `¿${props.partida.nick1} ha matado al general?`,
                    rules: [rules.isBool]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "Sí",
                        value: true
                      }),
                      _createVNode(_component_v_radio, {
                        label: "No",
                        value: false
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "rules"]),
                  _createVNode(_component_v_radio_group, {
                    modelValue: partidaEditada.value.liderMuertoUsuario2,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((partidaEditada.value.liderMuertoUsuario2) = $event)),
                    label: `¿${props.partida.nick2} ha matado al general?`,
                    rules: [rules.isBool]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "Sí",
                        value: true
                      }),
                      _createVNode(_component_v_radio, {
                        label: "No",
                        value: false
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "rules"]),
                  _createVNode(_component_v_radio_group, {
                    modelValue: partidaEditada.value.partidaValidadaUsuario1,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((partidaEditada.value.partidaValidadaUsuario1) = $event)),
                    label: `¿Validar la partida de ${props.partida.nick1}?`,
                    rules: [rules.isBool]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "Sí",
                        value: true
                      }),
                      _createVNode(_component_v_radio, {
                        label: "No",
                        value: false
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "rules"]),
                  _createVNode(_component_v_radio_group, {
                    modelValue: partidaEditada.value.partidaValidadaUsuario2,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((partidaEditada.value.partidaValidadaUsuario2) = $event)),
                    label: `¿Validar la partida de ${props.partida.nick2}?`,
                    rules: [rules.isBool]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "Sí",
                        value: true
                      }),
                      _createVNode(_component_v_radio, {
                        label: "No",
                        value: false
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "rules"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                small: "",
                variant: "tonal",
                color: "primary",
                onClick: confirmarEditarPartida,
                disabled: !isFormValid.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirmar ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                small: "",
                variant: "tonal",
                color: "secondary",
                onClick: cerrarModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})